<template>
	<div class="p-categories-admin">
		<template slot="header">
			<!-- <filter-bar :showSort="true"></filter-bar> -->
		</template>
		<page-title>{{ docType.singular | capitalize }} Tags</page-title>

		<section-block>
			<template slot="actions" v-if="$route.meta.isAdmin">
				<base-button
					:primary="true"
					@click="$router.push({ name: 'TagCreate' })"
					>Create Tag</base-button
				>
			</template>

			<vuetable
				class="c-data-table"
				:api-mode="false"
				:fields="table.fields"
				:data="tags"
				@vuetable:row-clicked="onRowClicked"
			>
				<template slot="date-created" slot-scope="props">
					<base-datetime :date="props.rowData.created_time"></base-datetime>
				</template>
				<template slot="category-actions" slot-scope="props">
					<category-actions
						route-path="TagEdit"
						:id="props.rowData.id"
						delete-action="tags/deleteDocumentTag"
						singular="tag"
					/>
				</template>
			</vuetable>
		</section-block>
	</div>
</template>

<script>
import Vue from 'vue'

// import FilterBar from "@/components/FilterBar";
import CategoryActions from '@/components/CategoryActions'

Vue.component('category-actions', CategoryActions)

export default {
	name: 'tags-admin',

	data() {
		return {
			loading: false,
			table: {
				fields: [
					{
						name: 'name',
						titleClass: 'u-ta-left',
						title: 'Tag Name',
						width: '20%',
					},
					{
						name: 'date-created',
						titleClass: 'u-ta-left',
						title: 'Date Created',
						width: '20%',
					},
					{
						name: 'category-actions',
						title: 'Actions',
						titleClass: 'u-ta-center u-hide-mobile',
						dataClass: 'u-ta-center u-hide-mobile',
						width: '10%',
					},
				],
			},
		}
	},

	created() {
		const { docType } = this.$route.params
		this.$store.dispatch('documents/init', { docType })
		this.$store.dispatch('tags/listDocumentTags')
	},

	methods: {
		onRowClicked(dataItem, event) {
			if (
				dataItem.event.target.localName === 'td' ||
				dataItem.event.target.parentNode.localName === 'td'
			) {
				this.$router.push({
					name: 'TagEdit',
					params: { categoryId: dataItem.data.id },
				})
			}
		},
	},

	computed: {
		docType() {
			return this.$store.state.documents.docType
		},

		tags() {
			return this.$store.state.tags.collection
		},
	},
}
</script>

<style lang="scss" scoped>
td > td {
  border: none;
  padding: 0;
  display: inline-block;
}
</style>
